export const FETCH_INVOICE_LIST_REQUEST = "FETCH_INVOICE_LIST_REQUEST";
export const FETCH_INVOICE_LIST_SUCCESS = "FETCH_INVOICE_LIST_SUCCESS";
export const FETCH_INVOICE_LIST_FAILURE = "FETCH_INVOICE_LIST_FAILURE";

export const DOWNLOAD_INVOICE_FILE_REQUEST = "DOWNLOAD_INVOICE_FILE_REQUEST";
export const DOWNLOAD_INVOICE_FILE_SUCCESS = "DOWNLOAD_INVOICE_FILE_SUCCESS";
export const DOWNLOAD_INVOICE_FILE_FAILURE = "DOWNLOAD_INVOICE_FILE_FAILURE";

export const GET_INVOICE_DETAILS_BY_ID_REQUEST = "GET_INVOICE_DETAILS_BY_ID_REQUEST";
export const GET_INVOICE_DETAILS_BY_ID_SUCCESS = "GET_INVOICE_DETAILS_BY_ID_SUCCESS";
export const GET_INVOICE_DETAILS_BY_ID_FAILURE = "GET_INVOICE_DETAILS_BY_ID_FAILURE";

export const ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST = "ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST";
export const ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS = "ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS";
export const ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE = "ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE";
